import React from "react"

import RichMediaMaster from "./RichMediaMaster"
import { Color } from "../../../../constants/V2/color"

type Props = {
  backgroundVideo?: string
  backgroundImage: string
  backgroundImageAlt: string
  accentColor: Color
  superscriptText?: string
  titleText: string
  descriptionText: string
  buttonLink: string | YocoCom.YocoLink
  mobileGridOrder?: number
  isSliderChild?: boolean
  autoplay?: boolean
  trackingEvent?: string
  trackingEventKey?: string
  trackingEventValue?: string
}

const InfoTab = (props: Props) => {
  return <RichMediaMaster type="callToAction" {...props} />
}

export default InfoTab
